import { ForwardedRef, forwardRef, JSXElementConstructor, memo } from "react";
import { Flex } from "../../flex";
import { BaseRedoInputContainer } from "./base-redo-input-container";
import { BaseRedoInput, RedoInputSize } from "./base-redo-text-input";
import * as redoLinkInputCss from "./redo-link-input.module.css";
export interface RedoLinkInputProps {
  "data-dd-action-name"?: string;
  value: string;
  onClick: () => void;
  size?: RedoInputSize;
  label?: string;
  icon: JSXElementConstructor<any> | JSX.Element;
  placeholder?: string;
  uiSelector?: string;
}

export const RedoLinkInput = memo(
  forwardRef(function RedoLinkInput(
    {
      value,
      size = "sm",
      label,
      onClick,
      icon: Icon,
      placeholder,
      uiSelector,
      "data-dd-action-name": actionName,
    }: RedoLinkInputProps,
    ref: ForwardedRef<HTMLInputElement>,
  ) {
    return (
      <BaseRedoInputContainer
        className={redoLinkInputCss.container}
        data-arbiter="RedoLinkInput"
        data-dd-action-name={actionName}
        idPrefix="redo-link-input"
        label={label}
        size={size}
        uiSelector={uiSelector}
      >
        <BaseRedoInput
          data-dd-action-name={actionName}
          onClick={onClick}
          placeholder={placeholder}
          ref={ref}
          setValue={() => {}}
          size={size}
          state="link"
          value={value}
        />

        <Flex align="center" className={redoLinkInputCss.icon} justify="center">
          {typeof Icon === "function" ? <Icon /> : Icon}
        </Flex>
      </BaseRedoInputContainer>
    );
  }),
);
